export default "__VITE_ASSET__8b363736__"